
document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.product-swiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        freeMode: true,
        navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
        200: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween:15,
        },
        768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween:15,
        },
        990: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 30,
        },
        },
    });
});
